import { RadioButton, RadioButtonChangeEvent, RadioButtonProps } from 'primereact/radiobutton';
import { classNames } from 'primereact/utils';
import React from 'react';
import { Control, Controller, ControllerRenderProps, RegisterOptions } from 'react-hook-form';

type RHFRadioButtonProps = {
    control: Control<any>;
    name: string;
    rules?: RegisterOptions;
    inputProps: RadioButtonProps;
    onChange?: (e: RadioButtonChangeEvent, field: ControllerRenderProps) => void;
};

export const RHFRadioButton = ({ control, name, rules, inputProps, onChange }: RHFRadioButtonProps) => {
    return (
        <Controller
            name={name}
            control={control}
            rules={rules}
            render={({ field, fieldState }) => (
                <RadioButton
                    {...field}
                    ref={undefined}
                    inputRef={field.ref}
                    className={classNames({ 'p-invalid': fieldState.invalid })}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                            e.preventDefault();
                            field.onChange(inputProps.value);
                        } else if (e.key === ' ') {
                            field.onChange(inputProps.value);
                        }
                    }}
                    {...inputProps}
                    checked={field.value === inputProps.value}
                    {...(onChange && { onChange: (e: RadioButtonChangeEvent) => onChange(e, field) })}
                />
            )}
        />
    );
};
